import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { computed, watch } from "vue";
import { KeenSliderInstance, useKeenSlider } from "keen-slider/vue.es";
import { AutomatCylinderStoppingPhase, SpinAutomatState } from "@/casino/bonusomat/models/bonusomat-spin-types";

const oneSlideChangeDuration = 80;


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-automat-cylinder',
  props: {
    iconsUrls: {},
    state: {},
    winIcon: {},
    spinEndDelay: {}
  },
  emits: ["spinEnd"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const oneRoundIndex = computed(() => props.iconsUrls.length * -1);
const oneRoundAnimationSettings = computed(() => {
    return { duration: oneSlideChangeDuration * props.iconsUrls.length, easing: (t) => t };
});

const winIndex = computed(() => props.iconsUrls.indexOf(props.winIcon) - props.iconsUrls.length);
const prepareIndexAnimationSettings = computed(() => {
    return { duration: oneSlideChangeDuration * winIndex.value, easing: (t) => t };
});

const finishSlideAnimationSettings = computed(() => {
    return {
        duration: oneSlideChangeDuration * props.iconsUrls.length * 2 + props.spinEndDelay,
        easing: (t) => (t -= 1) * t * t + 1,
    };
});

let sliderPositionMemory = 0;
let sliderSettingMemory = null;
const setNextSpin = (slider: KeenSliderInstance, increaseIdxBy: number, currentSettings) => {
    sliderPositionMemory = slider.track.details.abs + increaseIdxBy;
    sliderSettingMemory = currentSettings;
    slider.moveToIdx(sliderPositionMemory, true, sliderSettingMemory);
};

const restoreCurrentSpin = (slider: KeenSliderInstance) => {
    slider.moveToIdx(sliderPositionMemory, true, sliderSettingMemory);
};

let stoppingPhase: AutomatCylinderStoppingPhase = "PREPARE_INDEX";
const spinCylinderMachineState = (slider: KeenSliderInstance) => {
    if (props.state == "ROLLING") {
        // ROLLING is spinning round and round at full speed
        setNextSpin(slider, oneRoundIndex.value, oneRoundAnimationSettings.value);
        console.log(props.state, stoppingPhase, slider.track.details.abs, sliderPositionMemory);
    } else if (props.state == "STOPPING") {
        if (stoppingPhase == "PREPARE_INDEX") {
            // PREPARE INDEX phase turn around to the end position at full speed
            setNextSpin(slider, winIndex.value, prepareIndexAnimationSettings.value);
            console.log(props.state, stoppingPhase, slider.track.details.abs, sliderPositionMemory);
            stoppingPhase = "FINISH_SLIDE";
        } else if (stoppingPhase == "FINISH_SLIDE") {
            // FINISH_SLIDE phase spins 1 round with inertia
            setNextSpin(slider, oneRoundIndex.value, finishSlideAnimationSettings.value);
            console.log(props.state, stoppingPhase, slider.track.details.abs, sliderPositionMemory);
            stoppingPhase = "TRIGGER_END";
        } else {
            // TRIGGER_END finishes the process
            emit("spinEnd");
            stoppingPhase = "PREPARE_INDEX";
        }
    }
};

const [container, keenSlider] = useKeenSlider({
    loop: true,
    vertical: true,
    drag: false,
    mode: "free-snap",
    renderMode: "performance",
    slides: { perView: "auto", spacing: 0 },
    selector: ".bonusomat-automat-cylinder__card",

    animationEnded(slider: KeenSliderInstance) {
        spinCylinderMachineState(slider);
    },

    updated(slider: KeenSliderInstance) {
        // restore slider spin
        if (props.state == "ROLLING" || props.state == "STOPPING") {
            if (slider.track.details.abs == sliderPositionMemory) {
                spinCylinderMachineState(slider);
            } else {
                console.log("restore", slider.track.details.abs, sliderPositionMemory);
                restoreCurrentSpin(slider);
            }
        }
    },
});

watch(
    () => props.state,
    (newState) => {
        if (newState == "ROLLING") {
            spinCylinderMachineState(keenSlider.value);
        }
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bonusomat-automat-cylinder",
    ref_key: "container",
    ref: container
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconsUrls, (iconUrl, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "bonusomat-automat-cylinder__card",
        key: `wh-i${index}`
      }, [
        _createVNode(WebpImage, {
          alt: `Cylinder item ${index}`,
          cssClass: "bonusomat-automat-cylinder__card-image",
          src: iconUrl
        }, null, 8, ["alt", "src"])
      ]))
    }), 128))
  ], 512))
}
}

})